import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';

export interface IFileUploadStyles {
  root?: IStyle;
  input?: IStyle;
  messagebar?: IStyle;
  remove?: IStyle;
}

export const fileUploadStylesDefault = (theme: IH2OTheme): IFileUploadStyles => ({
  root: {
    height: 250,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: 5,
    border: '1px dashed',
    borderRadius: '8px',
    borderColor: theme.semanticColors?.inputBorder,
    backgroundColor: theme.semanticColors?.bodyBackground,
  },
  input: {
    opacity: 0,
    height: '8px',
  },
  messagebar: {
    margin: '20px 0',
  },
  remove: {
    fontSize: 20,
    position: 'absolute',
    top: '-15px',
    right: 0,
    cursor: 'pointer',
  },
});
